module.exports = __webpack_public_path__ + "static/media/culogo.72ebb72b.png";